const linkMustBeUsedOnce = (linkType) => {
  const linkTypesToBeUsedOnce = [2, 5, 7];
  return linkTypesToBeUsedOnce.includes(linkType);
};

module.exports = {
  linkMustBeUsedOnce,
};
